<template>
  <div>
    <paq-laboratorio
      v-if="isCatSelected('laboratorio')"
      :items="categorias.laboratorio"
      :buscar="buscarLaboratorios"
      @update:items="val => updateCategoria('laboratorio', val)"
    />

    <paq-imagen
      v-if="isCatSelected('imagenes')"
      :items="categorias.imagenes"
      :buscar="buscarImagenes"
      @agregar="val => $emit('agregar', 'imagenes', val)"
      @eliminar="val => $emit('eliminar', 'imagenes', val)"
    />

    <paq-procedimiento
      v-if="isCatSelected('procedimientos')"
      :items="categorias.procedimientos"
      :buscar="buscarProcedimientos"
      @update:items="val => updateCategoria('procedimientos', val)"
    />

    <paq-atencion-medica
      v-if="isCatSelected('atencion_medica')"
      :items="categorias.atencion_medica"
      @update:items="val => updateCategoria('atencion_medica', val)"
    />

    <paq-terapia
      v-if="isCatSelected('terapias')"
      :items="categorias.terapias"
      :buscar="buscarTerapias"
      @update:items="val => updateCategoria('terapias', val)"
    />
  </div>
</template>

<script>
import PaqLaboratorio from './PaqLaboratorio.vue'
import PaqImagen from './PaqImagen.vue'
import PaqProcedimiento from './PaqProcedimiento.vue'
import PaqAtencionMedica from './PaqAtencionMedica.vue'
import PaqTerapia from './PaqTerapia.vue'

export default {
  name: 'PaqServicios',
  components: { PaqLaboratorio, PaqImagen, PaqProcedimiento, PaqAtencionMedica, PaqTerapia },
  props: {
    serviceToggles: { type: Object, required: true },
    categorias: { type: Object, required: true },
    buscarLaboratorios: { type: Function, required: false },
    buscarImagenes: { type: Function, required: false },
    buscarProcedimientos: { type: Function, required: false },
    buscarTerapias: { type: Function, required: false },
  },
  methods: {
    isCatSelected (key) {
      return !!this.serviceToggles[key]
    },
    updateCategoria (key, val) {
      // Emitimos al padre para que reemplace el array correspondiente
      this.$emit('update-categoria', key, val)
    },
  }
}
</script>

<style scoped>
</style>
